import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import SummaryModal from './SummaryModal';
import { BPCreationSummary } from './types';

type Props = {
    summary?: BPCreationSummary | null;
    isLoading: boolean;
};

export default function CreateBPSummary(props: Props): React.ReactElement {
    const { summary, isLoading } = props;
    const { t } = useTranslation();

    return (
        <SummaryModal
            header={t('adminBudgetSpace.addBudgetSummary.description')}
            title={t('adminBudgetSpace.addBudgetSummary.title')}
            isError={false}
            isLoading={isLoading}
        >
            {summary &&
                summary.bpNames.map((str) => (
                    <Typography key={str}>{str}</Typography>
                ))}
        </SummaryModal>
    );
}
